
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seja-um-profissional/pagamentos",
      function () {
        return require("private-next-pages/seja-um-profissional/pagamentos/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/seja-um-profissional/pagamentos"])
      });
    }
  